import React, { Component } from 'react';
import { convertLocalDate } from './cleanDates';

export const DateFormatter = React.createClass({
  render() {
    return (this.props.value) ?
      <span>{convertLocalDate(this.props.value, 'MMM DD YYYY')}</span> :
      <span className="label label-danger">-</span>;
  },
});

export const formatDate = (date) => {
  if (!date) { return; }
  let formattedDate = `${date.getFullYear()}-`;
  formattedDate += `${date.getMonth() + 1}-`;
  if (date.getDate() < 10) {
    formattedDate += `0${date.getDate()}`;
  } else {
    formattedDate += date.getDate();
  }
  return formattedDate;
};

export default DateFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/dateFormat.jsx